function initCategoryCarousels() {
  document
    .querySelectorAll('.cat-carousel__swiper:not([data-cc-bound])')
    .forEach((swiperElement) => {
      swiperElement.setAttribute('data-cc-bound', 'true');

      const section = swiperElement.closest('.cat-carousel');
      const currentElement = section.querySelector('[data-cat-carousel-current]');
      const captionElement = section.querySelector('[data-cat-carousel-active-caption]');
      const progressFill = section.querySelector('[data-cat-carousel-progress-fill]');
      const previousButton = section.querySelector('[data-cat-carousel-previous]');
      const nextButton = section.querySelector('[data-cat-carousel-next]');
      const slideCount = Number(swiperElement.dataset.slideCount);

      previousButton?.addEventListener('click', () => {
        swiperElement.swiper?.slidePrev();
      });

      nextButton?.addEventListener('click', () => {
        swiperElement.swiper?.slideNext();
      });

      const updateActive = () => {
        const activeSlide = swiperElement.querySelector(
          '.cat-carousel__item.swiper-slide-active'
        );

        if (!activeSlide) return;

        const activeIndex = Number(activeSlide.dataset.realIndex);
        const currentNumber = activeIndex + 1;

        if (currentElement) currentElement.textContent = currentNumber;
        if (captionElement) captionElement.textContent = activeSlide.dataset.caption || '';
        if (progressFill && slideCount > 0) {
          progressFill.style.width = `${(currentNumber / slideCount) * 100}%`;
        }
      };

      const observer = new MutationObserver(updateActive);
      observer.observe(swiperElement, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
      });

      updateActive();
    });
}

document.addEventListener('DOMContentLoaded', initCategoryCarousels);
document.addEventListener('shopify:section:load', initCategoryCarousels);
